module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"open":"Bulk actions","clearSelection":"Clear selection","save":"Submit jobs","selectAll":"Select all","submitted":"Jobs submitted"}}')
  delete Component.options._Ctor
}
